/** Sección 15 del encargo P0.23 -- "Evolución" de Mi Banca/Mi Reto, construida con datos
 * REALES del historial de movimientos (`balance_after` de cada transacción), nunca un
 * endpoint gráfico nuevo (Sección 26: reutilizar un read-model ya existente cuando alcanza).
 * SVG puro sin librería externa -- evita una dependencia de peso solo para una línea simple
 * (Sección 23: performance / tamaño de bundle). */
export function EvolutionChart({ points }: { points: number[] }) {
  if (points.length < 2) {
    return (
      <div className="h-24 flex items-center justify-center text-[11px] text-text-dim italic">
        Necesitas al menos 2 movimientos para ver la evolución.
      </div>
    )
  }

  const width = 300
  const height = 90
  const min = Math.min(...points)
  const max = Math.max(...points)
  const range = max - min || 1
  const stepX = width / (points.length - 1)

  const coords = points.map((p, i) => {
    const x = i * stepX
    const y = height - ((p - min) / range) * (height - 8) - 4
    return [x, y] as const
  })
  const path = coords.map(([x, y], i) => `${i === 0 ? 'M' : 'L'}${x.toFixed(1)},${y.toFixed(1)}`).join(' ')
  const areaPath = `${path} L${width},${height} L0,${height} Z`
  const positive = points[points.length - 1] >= points[0]

  return (
    <svg viewBox={`0 0 ${width} ${height}`} className="w-full h-24" preserveAspectRatio="none">
      <defs>
        <linearGradient id="evolution-fill" x1="0" y1="0" x2="0" y2="1">
          <stop offset="0%" stopColor={positive ? 'rgb(167 237 32)' : 'rgb(255 69 58)'} stopOpacity="0.25" />
          <stop offset="100%" stopColor={positive ? 'rgb(167 237 32)' : 'rgb(255 69 58)'} stopOpacity="0" />
        </linearGradient>
      </defs>
      <path d={areaPath} fill="url(#evolution-fill)" stroke="none" />
      <path d={path} fill="none" stroke={positive ? 'rgb(167 237 32)' : 'rgb(255 69 58)'} strokeWidth="2" strokeLinejoin="round" strokeLinecap="round" />
    </svg>
  )
}
